<template>
  <div id="app">
    <div v-if="isLogin">
      <router-view />
    </div>
  </div>
</template>

<script>
import { post } from "./script/api.js";

export default {
  name: 'App',
  data() {
    return {
      isLogin: false,
    };
  },
  mounted() {
    if (
      window.localStorage.getItem("refreshToken") &&
      window.localStorage.getItem("accessToken")
    ) {
      //拿accessToken
      post("getToken", {}).then((res) => {
        if (res.code == 0) {
          localStorage.setItem('accessToken', res.data);
        }
        this.isLogin = true;
      });
    } else {
      //跳转登录界面
      this.isLogin = true;
    }
  },
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  /* width: 100%;
  height: 100%; */
  min-width: 1280px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue